<div class="p-grid" *ngIf="moduleName != 'SalesOrder'">
  <div [ngClass]="{'p-col-12 p-lg-12': selectedView=='list', 'p-col-12 p-lg-3':selectedView=='split'}">
    <div class="card">
      <p-contextMenu #cm [model]="configMenuItemsCM"></p-contextMenu>
      <p-table #contacts [columns]="contactCols" [value]="contactsData" selectionMode="single"
        [(selection)]="selectedContact" dataKey="id" (onRowSelect)="onRowSelect($event);"
        (onRowUnselect)="selectedContact = null; selectedView='list'" [(contextMenuSelection)]="selectedContact"
        [contextMenu]="cm" [scrollable]="true" [style]="{width:'100%'}">
        <ng-template pTemplate="header">
          <tr>
            <th id="firstName">Contact ID</th>
            <th id="designation">Designation</th>
            <th id="firstName">Contact Name</th>
            <th id="phone">Phone</th>
            <th id="email">Email</th>
            <th id="childAccountAccess" *ngIf="moduleName === 'Account' && object?.hasChildAccounts">Sub Accounts Access</th>
            <th id="RelationType" *ngIf="moduleName === 'Account' && object?.mainCustomerId">Relation Type</th>
            <th id="isActive">Is Active</th>
            <th id="">Is Primary</th>
            <th id="action">Action</th>
            <th id="create_contact" *ngIf="writePermission">
              <i class="pi pi-plus" style="cursor: pointer;" (click)="newContact($event)"></i>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-contact>
          <tr>
            <td>
                {{ contact?.sequenceNumber }}
            </td>
            <td>
              {{ contact?.designation }}
            </td>
            <td>
              {{ contact?.fullName || contact?.firstName + ' ' + contact?.lastName }}
            </td>
            <td>
              {{ contact?.phone.number | phoneNumber: contact.phone.code }}
            </td>
            <td>
              {{ contact?.email }}
            </td>
            <td *ngIf="moduleName === 'Account' && object?.hasChildAccounts">
                <span class="hyper-link" (click)="showRelationship(contact)">{{ contact?.childAccountAccess }}</span>
            </td>
            <td *ngIf="moduleName === 'Account' && object?.mainCustomerId">
              {{ contact?.parentChildRelationType ?  contact?.parentChildRelationType: 'Parent'}}
            </td>
            <td>
              {{ contact.statusId == 1 ? 'Yes' : 'No' }}
            </td>
            <td [disabled]="contact?.parentChildRelationType === 'Parent'|| contact.statusId === 2">
              <!-- <p-radioButton class="p-mr-1" [value]="contact.isPrimaryContact" [(ngModel)]="contact.isPrimaryContact"
                (click)="makeContactPrimary(contact.id)">
              </p-radioButton> -->
              <div
                class="primary-checkbox {{ contact.isPrimaryContact ? 'checked' : 'unchecked' }}"
                [ngClass]="{'disabled': contact.statusId !== 1}" (click)="makeContactPrimary(contact)"></div>
              {{ contact?.isPrimaryContact ? 'Yes' : 'No' }}
            </td>
            <td class="action">
              <span *ngIf="contact.statusId !== 2" class="btnBars p-mr-0" (click)="showEditContact({ id: contact.id, contactAssociationTypeId: contact?.contactAssociationTypeId, mode: 'edit' })"
                tooltipPosition="top" pTooltip="Edit">
                <i class="pi pi-pencil"></i>
              </span>
              <span class="btnBars p-mr-0" (click)="showEditContact({ id: contact.id, contactAssociationTypeId: contact?.contactAssociationTypeId, mode: 'view' })"
                tooltipPosition="top" pTooltip="View">
                <i class="pi pi-eye"></i>
              </span>
              <span *ngIf="contact.statusId !== 2" class="btnBars p-mr-0" (click)="deleteContact(contact)" tooltipPosition="top"
                pTooltip="Delete">
                <i class="pi pi-trash"></i>
              </span>
              <span class="btnBars p-mr-0" (click)="showRelationship(contact)" tooltipPosition="top" *ngIf="moduleName === 'Account' && object?.hasChildAccounts"
                pTooltip="Relationship">
                <i class="pi pi-sitemap"></i>
              </span>
            </td>
            <td *ngIf="writePermission"></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="10">{{noContactFindOrLoadingText}}</td>
          </tr>
        </ng-template>
      </p-table>
      <p-overlayPanel #op [showCloseIcon]="false" appendTo="body" [dismissable]="true">
        <ng-template pTemplate>
          <input pInputText type="text" #inputS [(ngModel)]="curCol.value"
            (input)="contacts.filter(curCol.value, curCol.field, 'contains')" placeholder="Search by {{curCol.header}}"
            class="p-column-filter"
            [value]="contacts.filters[curCol.field] ? contacts.filters[curCol.field].value : ''">
        </ng-template>
      </p-overlayPanel>
    </div>
  </div>
  <div class="p-col-12 p-lg-9" *ngIf="selectedView == 'split' && selectedContact">
    <div class="p-grid">
      <div class="p-col-12">
        <p-menu #configmenu id="config_menu" *ngIf="configMenuItems.length" [model]="configMenuItems"
          [popup]="true"></p-menu>
        <div class="p-grid" style="margin-bottom: 10px;">
          <ng-container *ngFor="let col of contactCols2">
            <div class="p-col" *ngIf="col.show">
              <div class="leaddesc card" *ngIf="filteredContacts.length > 0">
                <div class="label">{{col.header}}</div>
                <!-- <div class="leaddescName" (click)="showViewContact({id:selectedId})">
                  {{filteredContacts[0][col.field]}}
                </div> -->
                <div [ngClass]="{'leaddescName':col.field == 'fullName'}">
                  <span *ngIf="col.field == 'fullName'"
                    (click)="showEditContact({id:selectedId, mode:'view'})">{{filteredContacts[0][col.field]}}</span>
                  <span *ngIf="col.field != 'fullName'">{{filteredContacts[0][col.field]}}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- <p-overlayPanel #activityItems styleClass="activityItems">
          <ng-template pTemplate>
              <ul>
                <li (click)="displayActivityTaskAdd = true; activityItems.hide($event);">
                  <span><i class="pi pi-list p-mr-2"></i>Tasks</span>
                </li>
                <li (click)="displayAddEvent = true; activityItems.hide($event);">
                  <span><i class="pi pi-calendar-plus p-mr-2"></i>Events</span>
                </li>
                <li (click)="displaySendEmail = true; activityItems.hide($event);">
                  <span><i class="pi pi-envelope p-mr-2"></i>Email</span>
                </li>
                <li (click)="displayAddLog = true; activityItems.hide($event);">
                  <span><i class="pi pi-file p-mr-2"></i>Logs</span>
                </li>
                <li (click)="displayNotesAdd = true; activityItems.hide($event);">
                  <span><i class="pi pi-user-edit p-mr-2"></i>Notes</span>
                </li>
              </ul>
          </ng-template>
        </p-overlayPanel>
        <p-menubar>
          <ng-template pTemplate="start" style="width: 100%;">
            <span style="color: var(--primary-color);" class="p-ml-2">
              <strong>Activity Logs</strong>
            </span>
          </ng-template>
          <ng-template pTemplate="end" style="width: 100%;">
            <span class="btnBars" (click)="activityItems.toggle($event)">
              <i class="pi pi-bars"></i>
            </span>
          </ng-template>
        </p-menubar> -->

        <!-- <p-toolbar class="activity-toolbar">
          <div class="p-grid p-pl-2" style="width: calc(100% + 6px)">
            <div class="p-col p-lg-3 p-px-0 p-py-0" style="width: 20%">
              <button pButton class="p-button-info" style="width: 100%; border-radius: 0;" icon="pi pi-plus"
                label="Tasks" (click)="displayActivityTaskAdd = true"></button>
            </div>
            <div class="p-col p-lg-3 p-px-0 p-py-0" style="width: 20%">
              <button pButton class="p-button-danger" style="width: 100%; border-radius: 0;" icon="pi pi-plus"
                label="Events" (click)="displayAddEvent = true"></button>
            </div>
            <div class="p-col p-lg-3 p-px-0 p-py-0" style="width: 20%">
              <button pButton class="p-button-warning" style="width: 100%; border-radius: 0;" icon="pi pi-plus"
                label="Email" (click)="displaySendEmail = true"></button>
            </div>
            <div class="p-col p-lg-3 p-px-0 p-py-0" style="width: 20%">
              <button pButton class="p-button-info" style="width: 100%; border-radius: 0;" icon="pi pi-plus"
                label="Logs" (click)="displayAddLog = true"></button>
            </div>
            <div class="p-col p-lg-3 p-px-0 p-py-0" style="width: 20%">
              <button pButton class="p-button-success" style="width: 100%; border-radius: 0;" icon="pi pi-plus"
                label="Notes" (click)="displayNotesAdd = true"></button>
            </div>
          </div>
        </p-toolbar> -->

        <div>
          <app-lion-shared-activities [objectId]="selectedContactFromTable" [isViewMode]="isViewMode"
            [hideRigthArrow]="hideRigthArrow"></app-lion-shared-activities>
          <!-- <app-lion-shared-tasks [displayTaskAdd]="displayActivityTaskAdd" (cancelTask)="cancelTask($event)">
          </app-lion-shared-tasks>
          <app-lion-shared-notes [displayNotesAdd]="displayNotesAdd" (cancelNote)="cancelNote($event)">
          </app-lion-shared-notes>
          <app-lion-shared-logs [displayAddLog]="displayAddLog" (cancelLog)="cancelLog($event)">
          </app-lion-shared-logs>
          <app-lion-shared-events [displayAddEvent]="displayAddEvent" (cancelEvent)="cancelEvent($event)">
          </app-lion-shared-events>
          <app-lion-shared-emails [displaySendEmail]="displaySendEmail" (cancelEmail)="cancelEmail($event)">
          </app-lion-shared-emails> -->
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="moduleName == 'SalesOrder'">
  <span class="btnBars" style="cursor: pointer;" (click)="soModuleContact($event)">
    <i class="pi pi-plus"></i>
  </span>
</div>

<!-- add/edit/view contact dialog -->
<!-- <app-add-edit-contact-modal [header]="contactModalHeader" [moduleName]="moduleName" [formtype]="contactPopupOpenMode"
  [display]="displayContactAddEdit" [object]="newObject" [associationName]="associationName" [isViewMode]="isViewMode"
  [selectedLanguage]="selectedLanguage" [selectedRelation]="selectedRelation" [selectedIncome]="selectedIncome"
  [selectedDegree]="selectedDegree" [selectedGender]="selectedGender" [selectedStudyField]="selectedStudyField"
  [selectedMarital]="selectedMarital" [selectedContactRole]="selectedContactRole" [selectedSource]="selectedSource"
  [reports]="reports" [useReport]='true' [contactTemp]="contactTemp" [selectedContactType]="selectedContactType"
  [selectedAssistant]="selectedAssistant" [selectedContactAssociation]="selectedContactAssociation"
  [selectedReportsTo]="selectedReportsTo" [addressCountry]="addressCountry" [addressState]="addressState"
  [addressCity]="addressCity" [states]="states" [cities]="cities" [contactAssociationList]="contactAssociation"
  [accountAddressTypes]="accountAddressTypes" [addressClasses]="addressClasses" [countries]="countries"
  [genderList]="genders" [languageList]="languages" [sourceList]="sources" [contactTypeList]="contactTypes"
  [salutationList]="salutations" [relationList]="relations" [maritalList]="maritals" [incomeList]="incomes"
  [degreeList]="degrees" [studyFieldList]="studyFields" [contactRoleList]="contactRoles" [addUpdateDone]="addUpdateDone"
  [labels_info]="labels_info" [labels_address]="labels_address" [isDisableAssociation]="isDisableAssociation"
  (saveClicked)="saveData($event)" (cancelClicked)="cancelAddContact($event)" [selectedChannelN]="selectedChannelN">
</app-add-edit-contact-modal> -->

@if(displayContactAddEdit){
<app-add-edit-form
  [displayContactAddEdit]="displayContactAddEdit"
  [contactModalHeader]="contactModalHeader" [selectedContactAssociation]="selectedContactAssociation"
  [mode]="contactPopupOpenMode" [businessName]="associationName"
  [selectedChannel]="selectedChannel"
  [selectedContact]="selectedContact"
  [associationTypeName]="associationTypeName" [selectedRecord]="object"
  (displayContactAddEditChange)="onDisplayChange($event)"
  >
  <!-- (loadContactList)="loadContacts()" -->
</app-add-edit-form>
}

<p-dialog header="Relationship" [(visible)]="displayRelationship" [modal]="true" [closable]="false"
    [style]="{width: '60vw'}">
    <div class="card">
      <p-table [value]="relationship" responsiveLayout="scroll">
        <ng-template pTemplate="header">
            <tr>
                <th>Child Account</th>
                <th class="action">
                  <p-checkbox [ngModelOptions]="{standalone: true}" (onChange)="checkAllAccess()"
                    [(ngModel)]="hasAccessAll" binary="true"></p-checkbox>
                  Access
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-relation>
            <tr>
                <td>{{relation.sequenceNumber}} - {{relation.name}}</td>
                <td>
                  <p-checkbox [ngModelOptions]="{standalone: true}" (onChange)="changeAllAccess()"
                    [(ngModel)]="relation.hasAccess" binary="true"></p-checkbox>
                </td>
            </tr>
        </ng-template>
      </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayRelationship=false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="submit" pButton label="Save" (click)="saveRelationship()"></button>
    </p-footer>
</p-dialog>
